import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { formatWhatsAppText } from "../../utils/whatsappTextFormat";

const InteractiveMessage = ({ message }) => {
  const buttons = Array.isArray(message?.buttons) ? message.buttons : [];
  const html = message?.text ? formatWhatsAppText(message.text) : "";

  return (
    <Box>
      {message?.text ? (
        <Typography
          component="div"
          dangerouslySetInnerHTML={{ __html: html }}
          sx={{
            wordBreak: "break-word",
            whiteSpace: "pre-wrap",
            "& a": { color: "primary.main", wordBreak: "break-all" },
            "& code": { fontFamily: "monospace", fontSize: "0.9em" },
          }}
        />
      ) : null}
      {buttons.length > 0 && (
        <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: message?.text ? 1 : 0 }}>
          {buttons.map((button, index) => (
            <Chip
              key={index}
              size="small"
              label={button.label || button.title || `Opção ${index + 1}`}
              variant="outlined"
              sx={{ borderStyle: "dashed" }}
            />
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default InteractiveMessage;
